import { Calendar, CalendarRange, Ticket, Shuffle, LayoutDashboard, MonitorDot } from 'lucide-react';
import KayCeeKopf from './KayCeeKopf';

// #562: Die Reiter des Headers als EINE Liste. Reiterleiste (Desktop) und
// Burger-Menue (schmale Breite) rendern daraus; vorher standen sie zweimal im
// Header, mit denselben Rollen-Regeln von Hand gepflegt. #568 (Reiter waehlbar)
// und #552 (eigene Listen) setzen hier an.
//
// Regeln (Stand v2.6.0, #44-Revision 2026-10-19):
//   - Dashboard und Kalender: alle
//   - Pool-Monitor: nur Manager, und nur im Burger-Menue
//   - Alle Tickets, Alle Kalender, Vorgaenge, KI-Suche: nur Manager
// `desktopIcon: false`: Das Dashboard steht in der Reiterleiste ohne Symbol
// (ausser bei „nur Symbol“). Jeder Reiter hat sein eigenes Symbol, sonst sind
// sie bei „nur Symbol“ nicht zu unterscheiden (#607: „Alle Kalender“ mit
// CalendarRange, den Zeilen je Person).
//
// #568: Reiter lassen sich in den Einstellungen ausblenden (Schlüssel
// `reiter`, Liste der AUSGEBLENDETEN ids). Ein neuer Reiter erscheint damit
// von selbst und bekommt seinen Schalter. Ausblenden ist eine Vorliebe, kein
// Recht: Was die Rolle nicht erlaubt, bleibt unsichtbar, auch wenn es nicht
// ausgeblendet ist. `fest`: lässt sich nicht ausblenden (das Dashboard ist
// die Startseite).

const istManager = (user) => !!user?.dbUser?.isManager;
const alle = () => true;

export const REITER = [
  { id: 'dashboard', pfad: '/dashboard', Icon: LayoutDashboard, textKey: 'header.dashboard', text: 'Dashboard', sichtbar: alle, desktopIcon: false, fest: true },
  { id: 'calendar', pfad: '/calendar', Icon: Calendar, textKey: 'header.calendar', text: 'Kalender', sichtbar: alle },
  { id: 'pool', pfad: '/pool', Icon: MonitorDot, textKey: 'header.poolMonitor', text: 'Pool-Monitor', sichtbar: istManager, nurBurger: true },
  { id: 'tickets', pfad: '/tickets', Icon: Ticket, textKey: 'header.allTickets', text: 'Alle Tickets', sichtbar: istManager },
  { id: 'global-calendar', pfad: '/global-calendar', Icon: CalendarRange, textKey: 'header.allCalendars', text: 'Alle Kalender', sichtbar: istManager },
  { id: 'projects', pfad: '/projects', Icon: Shuffle, textKey: 'header.projects', text: 'Vorgänge', sichtbar: istManager },
  { id: 'search', pfad: '/search', Icon: KayCeeKopf, textKey: 'header.aiSearch', text: 'KI-Suche', sichtbar: istManager }
];

/**
 * @param {'leiste'|'burger'} ort
 * @param {string[]} [ausgeblendet]  ids aus den Benutzer-Einstellungen
 */
export function sichtbareReiter(user, ort, ausgeblendet = []) {
  const aus = Array.isArray(ausgeblendet) ? ausgeblendet : [];
  return REITER.filter((r) => (ort === 'burger' || !r.nurBurger) && r.sichtbar(user) && (r.fest || !aus.includes(r.id)));
}

/**
 * Reiter, die jemand in den Einstellungen ausblenden kann: die er sehen darf,
 * ohne feste. Der Pool-Monitor steht nur im Burger-Menü und bleibt dort, ein
 * Schalter, der am Arbeitsplatz nichts sichtbar ändert, verwirrt nur.
 */
export function waehlbareReiter(user) {
  return REITER.filter((r) => !r.fest && !r.nurBurger && r.sichtbar(user));
}
